<template>
  <v-layout row wrap>
    <v-flex xs12 md4 class="extra-pad">
      <v-layout row wrap>
        <v-tooltip bottom>
          <template slot="activator">
            <v-icon color="primary" @click="_view(doc.ID, 0)">visibility</v-icon>
          </template>
          <div>View Document</div>
        </v-tooltip>
        <v-tooltip bottom>
          <template slot="activator">
            <v-icon color="primary" @click="_view(doc.ID, 1)">save_alt</v-icon>
          </template>
          <div>Download Document</div>
        </v-tooltip>
        <v-text-field label="Name" :value="doc.Name" readonly></v-text-field>
      </v-layout>
    </v-flex>
    <v-flex xs12 md4 class="extra-pad">
      <v-text-field
        label="Added By"
        :value="`${doc.User.FirstName} ${doc.User.LastName}`"
        readonly
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md4 class="extra-pad">
      <v-text-field label="Added On" :value="doc.AddedOn | formattedDate" readonly></v-text-field>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    doc: Object
  },
  data(){
    return {
      
    }
  },
  created(){
    
  },
  computed: {
    
  },
  methods: {
    _view(id, op) {
      let url = `Documents/${id}`
      axios
        .get(url)
        .then((response) => {
          let data = response.data
          let binary = atob(data.file.replace(/\s/g, ''))
          let len = binary.length
          let buffer = new ArrayBuffer(len)
          let view = new Uint8Array(buffer)
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i)
          }
          let blob = new Blob([view], { type: data.doc.Type })
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, data.doc.Name)
          } else {
            if (op == 0) {
              //Will not work if AdBlock is running in Chrome
              let blobUrl = URL.createObjectURL(blob)
              window.open(blobUrl)
            } else {
              let blobUrl = URL.createObjectURL(blob)
              let a = document.createElement('a')
              a.href = blobUrl
              a.download = data.doc.Name
              document.body.appendChild(a)
              a.click()
              setTimeout(function() {
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url)
              }, 0)
            }
          }
        })
        .catch((e) => {
          
        })
    },
  },
  watch: {
    
  },
  components: {
    
  },
}
</script>
<style scoped>
  
</style>